import axios from "axios";
import { resetUserState } from "../redux/actions/userAction.js";
import { store } from "../redux/Store.js";

// Set default axios configuration
axios.defaults.withCredentials = true;

// Create axios interceptor to handle authentication errors globally
axios.interceptors.response.use(
  (response) => response, // Pass through successful responses
  async (error) => {
    const originalRequest = error.config;

    // Handle 401 Unauthorized errors (expired tokens)
    if (error.response?.status === 401 && !originalRequest._retry) {
      // Clear user state in Redux
      store.dispatch(resetUserState());

      // Remove any stored tokens
      localStorage.removeItem("userToken");

      // Redirect to login page if not already there
      if (window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default axios;